module.exports = __webpack_public_path__ + "img/vision_01_2x.364b5f4f.jpg";